module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"isSpeaking":"Speaking","notSpeaking":"Tap To Talk","isListening":"Listening","isThinking":"Thinking"},"es":{"isSpeaking":"Discurso","notSpeaking":"Toca para hablar","isListening":"Escuchando","isThinking":"Pensando"}}')
  delete Component.options._Ctor
}
